import { atom } from 'recoil';

export const carInfoState = atom({
  key: 'carInfoState',
  default: {
    carNumber: '',
    carName: '',
    carScale: '',
    carYear: '',
    carRegion: '',
    carReservationDate:'',
    carRepairPart:'',
    userName:'',
    userPhoneNumber:'',
    userRequest:''
  }
});